export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../assets/images/industry/indus-banner.jpg'),
        title: '行业',
        description: 'MaesInfo提供量身定制的行业解决方案，以最好地满足您的业务和技术需求我们广泛的领域知识和经验。',
        component: ''
      }
  ],
  newslist:[
    {
      title: '银行',
      imgUrl: require('../../assets/images/industry/indus-pic-1.png'),
      description: `
        MaesInfo提供银行所需要的全价值链IT解决方案。我们有深厚的行业专业知识积累，高质量的交付体系和一流的服务能力，帮助银行更好地适应不断变化的数字金融市场，重构现代数字化业务模式 <br/>
        我们可以提供 <br/>
           <p class="zh_desc">
           <span> <i></i>新一代数字银行核心解决方案</span>
           <span> <i></i>国际结算与贸易融资方案</span>
           <span> <i></i>移动客户端与支付解决方案</span>
           <span> <i></i>风险财务数据分析把控</span>
           </p>
      `
    },
    {
      title: '高科技',
      imgUrl: require('../../assets/images/industry/indus-pic-2.png'),
      description: `
        MaesInfo作为一家高科技公司，深知当今高科技企业面临的困难与挑战，MaesInfo利用自身特有的资源与优势，结合服务全球知名高科技企业的最佳实践，帮助企业加速创新、助力增长、升级体验并优化企业运营
        <br/>
        我们可以提供 <br/>
           <p class="zh_desc">
           <span> <i></i>PaaS平台</span>
           <span> <i></i>服务器产品和解决方案</span>
           <span> <i></i>人工智能领域数据采集服务</span>
           <span> <i></i>软件产品编译支持服务</span>
           </p>
      `
    },
    {
      title: '保险',
      imgUrl: require('../../assets/images/industry/indus-pic-3.png'),
      description: `
      保险公司如何在数字化时代中保持利润增长？
MaesInfo通过为保险企业打造全流程一体化的解决方案，帮助您不断突破能力瓶颈，提升客户体验，升级服务
模式，倍增服务效率，提升企业竞争力。
        <br/>
        我们可以提供 <br/>
           <p class="zh_desc">
          最先进最完善的crm系统帮组您的挖掘客户、服务客户、留住客户各种保险产品的数据收集和分析的解决方案
           </p>
      `
    },
    {
      title: '金融',
      imgUrl: require('../../assets/images/industry/indus-pic-4.png'),
      description: `
      在金融企业全面数字化转型过程中，您需要在规避风险的情况下，转变经营业务的模式，发展互联网+的
经营模式。拥抱经济全球化的趋势，创建全球化的金融业务。MaesInfo做为一家全球化的公司，为国内外40多个
国家提供咨询、应用开发、测试和运营的解决方案，您完全可以信赖我们的服务和提供解决方案的能力。帮助您
抓住市场机遇并做出上佳决策。
<br/>
我们可以提供 <br/>
   <p class="zh_desc">
   <span> <i></i>crm系统</span>
   <span> <i></i>期货市场数据分析解决方案</span>
   </p>
      `
    },
    {
      title: '资本市场',
      imgUrl: require('../../assets/images/industry/indus-pic-5.png'),
      description: `
      全球化对资本市场产生了多方面的影响，资本市场的企业实现卓越绩效必须要深刻理解新兴经济秩序的动态趋势。
数字化时代，虚拟货币的盛行，移动支付的便捷，区块链技术的兴起，各种资本市场的企业亟需数字化转型。
MaesInfo可以帮助投资银行、交易所、结算机构、理财与资产管理公司、托管机构以及经纪人/交易商完成转型，
实现卓越绩效。我们面向资本市场行业提供的核心服务包括：
<br/>
   <p class="zh_desc">
   <span> <i></i>交易服务改善前台、中端和后台交易操作，并完成风险管理部门转型</span>
   <span> <i></i>市场基础设施服务帮助交易所和结算机构应对全球化市场运营挑战</span>
   <span> <i></i>理财与资产管理服务为理财与资产管理客户创建下一代业务模式</span>
   </p>
      `
    },
    {
      title: '软件',
      imgUrl: require('../../assets/images/industry/indus-pic-6.png'),
      description:`
      随着组织的发展，现成的软件不再满足企业环境的需要。大企业有它们自己的、独特的、业务流程、数据结构和
工作流，这就是企业应用的来源：它是专门为满足特定组织的需要而设计的大型软件平台。
MaesInfo的软件开发服务包括根据组织的需要定制的企业应用程序开发。我们的软件开发团队具有为世界各地
的客户构建软件应用程序的丰富经验
<br/>
我们可以提供 <br/>
   <p class="zh_desc row">
    <label class="line">
    <span> <i></i>支付处理系统</span>
    <span> <i></i>自动计费系统</span>
    <span> <i></i>CRM(客户关系管理)</span>
    </label>
    <label class="line">
    <span> <i></i>ERP(企业资源规划)</span>
    <span><i></i>BCP(业务连续性规划)</span>
    <span><i></i>RFID(射频识别) IT服务管理</span>
    </label>
   </p>
      `
    },
    {
      title: '能源',
      imgUrl: require('../../assets/images/industry/indus-pic-7.png'),
      description: `
      互联互通的科技将改变整个人类世界的运行方式,通过超级计算和云计算将物理网整合起来，借助IT互联网技术，
为能源生产与应用客户提供智能平台和能源解决方案。
<br/>
我们可以提供 <br/>
   <p class="zh_desc">
   <span> <i></i>GIS燃气管网地理信息系统</span>
   <span> <i></i>呼叫调度中心解决方案</span>
   <span> <i></i>远程数据采集与监控</span>
   <span> <i></i>移动办公手机app</span>
   </p>
      `
    },
    {
      title: '互联网',
      imgUrl: require('../../assets/images/industry/indus-pic-8.png'),
      description: `
      MaesInfo拥有全球化的数字化服务能力，运用领先的数字化技术，为众多知名互联网企业提供综合技术服务，
并助力传统企业进行互联网转型<br/>
我们可以提供 <br/>
   <p class="zh_desc">
   <span> <i></i>电子商务客服外包解决方案</span>
   <span> <i></i>电子商务体验交互解决方案</span>
   <span> <i></i>软件及网站可访问性测试服务</span>
   </p>

      `
    },
    {
      title: '汽车',
      imgUrl: require('../../assets/images/industry/indus-pic-9.png'),
      description: `
      如今汽车行业极速发展，5g时代让汽车可以连接手机电脑移动终端设备，实现司机对汽车更加便捷、智能化的
控制，如通过智能手机来控制汽车，用语音来给汽车下达指令
MaesInfo卓越的开发经验与研发能力将帮助您降低运营风险，提高运营收益，实现更完美的交互体验
<br/>
我们可以提供 <br/>
   <p class="zh_desc">
   <span> <i></i>移动客户端桌面深度定制解决方案</span>
   <span> <i></i>汽车信息娱乐系统自动化测试服务</span>
   <span> <i></i>智能网联汽车的开发和车连网的服务</span>
   </p>
      `
    },
    {
      title: '医疗健康',
      imgUrl: require('../../assets/images/industry/indus-pic-10.png'),
      description: `
      随着社会的发展，医疗行业面临着增速放缓、产业数字化转型及整合等时代趋势的挑战和机遇。如何化繁为简，
实现智能化医疗的新格局？
Maesinfo建立了idoctor平台，可以帮助您寻找到专业优秀的护理人员，提供社群社交、护理、专家咨询、照护、
日托、生活、紧急呼叫等服务
<br/>
我们可以提供 <br/>
   <p class="zh_desc">
   <span> <i></i>医疗行业应用开发和运营维护服务</span>
   <span> <i></i>医疗行业应用开发和运营维护服务</span>
   </p>
      `
    },
    {
      title: '媒体娱乐',
      imgUrl: require('../../assets/images/industry/indus-pic-11.png'),
      description: `
      MaesInfo助力媒体娱乐行业数字化转型，创新移动互联体验。
MaesInfo凭借丰富的实践经验和定制化的解决方案，帮助媒体和娱乐公司提高效率、优化技术和革新工艺，从而
为用户带来更为卓越的体验
<br/>
我们可以提供 <br/>
   <p class="zh_desc">
   <span> <i></i>电影评分数据爬虫分析</span>
   <span> <i></i>影视作品流量分析，观影群体分析</span>
   <span> <i></i>移动客户端的建立</span>
   </p>
      `
    },
    {
      title: '教育',
      imgUrl: require('../../assets/images/industry/indus-pic-12.png'),
      description: `
      互联网科技与教育领域相结合的一种新的教育形式，一场信息化的颠覆性变革正悄悄地发生着。线上教育可以让
全世界的优质教育资源共享，并最大程度的节约成本。学生也可以拓展他们的视野、启迪智慧。
MaesInfo也拥有自己的bbtalk线上教育平台，帮助各个年龄段的学员学习英语
<br/>
我们可以提供 <br/>
   <p class="zh_desc">
   <span> <i></i>教育产品的网页设计</span>
   <span> <i></i>Pc和移动端的互动程序设计</span>
   <span> <i></i>学员学习数据的分析</span>
   </p>
      `
    },
    {
      title: '旅行',
      imgUrl: require('../../assets/images/industry/indus-pic-13.png'),
      description: `
      随着经济的全球化和人均gdp的提高，人们对旅游的需求越来越多。maesinfo凭借在旅游、交通行业的深厚
积累，致力于为全球旅游和交通企业提供专业高效的数字化服务，从而为人们创造更智能的出行体验。<br/>
我们可以提供 <br/>
   <p class="zh_desc">
   <span> <i></i>ERP咨询和实施服务</span>
   <span> <i></i>线上营销解决方案</span>
   <span> <i></i>移动客户端平台搭建</span>
   </p>
      `
    },
    {
      title: '零售',
      imgUrl: require('../../assets/images/industry/indus-pic-14.png'),
      description: `
      5G时代的来临，网络购物、互联网经济的崛起对零售行业传统的线下营销方式造成了巨大的冲击。如何有效的
利用互联网和it软件有效的帮助企业为消费者创造个性化的购物体验，建立可持续的盈利发展模式？<br/>
我们可以提供 <br/>
   <p class="zh_desc">
   <span> <i></i>Crm系统运营和维护解决方案，让营销更加智能</span>
   <span> <i></i>Erp系统运营和维护解决方案，优化企业资源</span>
   <span> <i></i>物理网平台搭建</span>
   <span> <i></i>线上交易商场平台建设</span>
   <span> <i></i>移动客户端建设和维护</span>
   </p>
      `
    }
  ]
}
